import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";

import { dispatch } from "../../common/helpers";
import { practiceService } from "../../services";

import {
  FETCH_PRACTICE_REQUEST,
  FETCH_PRACTICE_SUCCESS,
  FETCH_PRACTICE_ERROR,
} from "./actions";

export const getPracticeList = (action$) => {
  return action$.pipe(
    ofType(FETCH_PRACTICE_REQUEST),
    mergeMap(({ payload }) => {
      return practiceService.getPracticeList(payload).pipe(
        map((response) => {
          return dispatch(FETCH_PRACTICE_SUCCESS, JSON.parse(response));
        }),
        catchError((error) => {
          return dispatch(FETCH_PRACTICE_ERROR, error);
        })
      );
    })
  );
};
